import { useRouter } from "next/router";

const useGetParams = () => {
  const router = useRouter();
  const { query } = router;

  const email =
    query.email && typeof query.email === "string" ? query.email : null;
  const goto = query.goto && typeof query.goto === "string" ? query.goto : null;
  const step = query.step && typeof query.step === "string" ? query.step : null;
  const type = query.type && typeof query.type === "string" ? query.type : null;
  const invitationId =
    query.invitationId && typeof query.invitationId === "string"
      ? query.invitationId
      : null;

  return {
    email,
    goto,
    step,
    type,
    invitationId,
  };
};

export default useGetParams;
